/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerUpdateMutationRequest, ApplicationsControllerUpdateMutationResponse, ApplicationsControllerUpdatePathParams, ApplicationsControllerUpdate400, ApplicationsControllerUpdate401, ApplicationsControllerUpdate403, ApplicationsControllerUpdate404 } from "../../models/checklistsController/ApplicationsControllerUpdate";

function getApplicationsControllerUpdateUrl(id: ApplicationsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-applications/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist application
 * {@link /api/v1/checklist-applications/:id}
 */
export async function applicationsControllerUpdate(id: ApplicationsControllerUpdatePathParams["id"], data?: ApplicationsControllerUpdateMutationRequest, config: Partial<RequestConfig<ApplicationsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationsControllerUpdateMutationResponse, ResponseErrorConfig<ApplicationsControllerUpdate400 | ApplicationsControllerUpdate401 | ApplicationsControllerUpdate403 | ApplicationsControllerUpdate404>, ApplicationsControllerUpdateMutationRequest>({ method : "PATCH", url : getApplicationsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}